import React from "react";
import bgImg from "../../../assets/Rectangle05.png";

const cards = [
  {
    number: "01",
    title: "Missing The Enrollment Window",
    description:
      "There's a limited window to sign up. Miss it, and you could carry a penalty on your monthly premium for the rest of your life.",
  },
  {
    number: "02",
    title: "Picking The Wrong Plan",
    description:
      "Not all Medicare plans cover the same things. Choosing without guidance often means surprise bills and gaps in care.",
  },
  {
    number: "03",
    title: "Assuming Coverage Is Automatic",
    description:
      "Unless you're already on Social Security, Medicare doesn't just kick in. You have to apply — and timing is everything.",
  },
];

const SemaglutideVisionLossOverview = () => {
  return (
    <section
      className="w-full font-[Quicksand] bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url(${bgImg})` }}
    >
      {/* Desktop + Tablet */}
      <div className="hidden md:block w-full">
        <div className="max-w-[1440px] mx-auto px-[80px] py-[60px]">

          {/* Heading */}
          <h2 className="mb-6 text-[35px] font-semibold leading-normal capitalize">
            <span className="text-[#0A1F8F]">What Most People Get Wrong About </span>
            <span className="text-[#EDC14A]">
              Medicare Enrollment
            </span>
          </h2>

          {/* Description */}
          <p className="text-[#757575] text-[18px] font-medium leading-relaxed mb-8 max-w-[1100px]">
            Medicare sounds straightforward until you're actually in it. The enrollment windows are strict, the plan options are confusing, and one wrong move can cost you for years. Many Americans sign up late, pick the wrong plan, or assume they're automatically covered — and end up paying the price.
          </p>

          {/* Sub Heading */}
          <h3 className="text-[#0A1F8F] text-[35px] font-semibold leading-normal mb-8">
            Where People Run Into Trouble
          </h3>

          {/* Cards */}
          <div className="grid grid-cols-2 gap-8">
            {cards.map((card, index) => (
              <article
                key={card.number}
                className={`p-6 rounded-[12px] bg-white shadow-sm ${
                  index === 2 ? "col-span-2" : ""
                }`}
              >
                <span className="text-[#0A1F8F] text-[24px] font-medium block mb-2">
                  {card.number}
                </span>

                <h4 className="text-[#EDC14A] text-[18px] font-semibold mb-2">
                  {card.title}
                </h4>

                <p className="text-[#0A1F8F] text-[16px] font-medium leading-relaxed">
                  {card.description}
                </p>
              </article>
            ))}
          </div>

        </div>
      </div>

      {/* Mobile */}
      <div className="md:hidden flex flex-col gap-6 px-4 py-8">

        {/* Heading */}
        <h2 className="text-left text-[24px] font-semibold leading-[1.2] capitalize">
          <span className="text-[#0A1F8F]">What Most People Get Wrong About </span>
          <span className="text-[#EDC14A]">
            Medicare Enrollment
          </span>
        </h2>

        {/* Description */}
        <p className="text-[#757575] text-[16px] font-medium leading-relaxed">
          Medicare sounds straightforward until you're actually in it. The enrollment windows are strict, the plan options are confusing, and one wrong move can cost you for years.
        </p>

        {/* Sub Heading */}
        <h3 className="text-[#0A1F8F] text-[24px] font-semibold leading-[1.2] capitalize">
          Where People Run Into Trouble
        </h3>

        {/* Cards */}
        <div className="flex flex-col gap-4">
          {cards.map((card) => (
            <div
              key={card.number}
              className="bg-white rounded-[12px] p-5 shadow-sm"
            >
              <span className="text-[#0A1F8F] text-[20px] font-medium block mb-2">
                {card.number}
              </span>

              <h4 className="text-[#EDC14A] text-[16px] font-semibold mb-1">
                {card.title}
              </h4>

              <p className="text-[#0A1F8F] text-[15px] font-medium leading-relaxed">
                {card.description}
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default SemaglutideVisionLossOverview;